<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ded"> </p>
<p class="DED">To Maisey, excellent CP and awesome friend. Here’s to having glassware!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1dc18de2